import React from 'react';
import { Link } from 'react-router-dom';

const SectionHeaderLink = ({ title, to, image }) => (
  <Link
    to={to}
    className={`section-header-link home-section-title${image ? ' league-news-feed__head home-section-title--league' : ''}`}
  >
    {image && (
      <div className="league-news-feed__logo-wrap">
        <img
          src={image}
          alt=""
          className="league-news-feed__logo"
        />
      </div>
    )}

    <div className={image ? 'league-news-feed__title-wrap' : undefined}>
      <h2 className={image ? 'league-news-feed__title' : 'section-header-link__title'}>
        {title}
      </h2>
    </div>
  </Link>
);

export default SectionHeaderLink;
